import React from 'react';
import {formatNumber} from '../../helpers/formatHelper';
import {formatCash} from '../../common/app';

import MainController from "./MainController";

function MainView(props) {
    const {method, state} = MainController(props);
    return (
        (state.isLoad) && <>
            {
                (state.isLogin) && (<div className="product-info-action__feedback">
                    <p className="product-info-action__feedback-item">
                        {/*<strong className="product-info-action__feedback-number red">5.0</strong>*/}
                        <span className="product-item__star"><span
                            className={(state.product?.productRateCount >= 1 ? "fa-solid fa-star checked" : "fa-solid fa-star")}></span><span
                            className={(state.product?.productRateCount >= 2 ? "fa-solid fa-star checked" : "fa-solid fa-star")}></span><span
                            className={(state.product?.productRateCount >= 3 ? "fa-solid fa-star checked" : "fa-solid fa-star")}></span><span
                            className={(state.product?.productRateCount >= 4 ? "fa-solid fa-star checked" : "fa-solid fa-star")}></span><span
                            className={(state.product?.productRateCount >= 5 ? "fa-solid fa-star checked" : "fa-solid fa-star")}></span>
                    </span>
                    </p>
                    <span className="product-info-action__feedback-separate">|</span>
                    <p className="product-info-action__feedback-item">
                        <strong
                            className="product-info-action__feedback-number">{formatCash(state.product?.productCommentCount)}</strong>Đánh
                        giá
                    </p>
                    <span className="product-info-action__feedback-separate">|</span>
                    <p className="product-info-action__feedback-item">
                        <strong
                            className="product-info-action__feedback-number">{formatCash(state.product?.quantityUse)}</strong>Đã
                        bán
                    </p>
                </div>)
            }
            <hr className="product-info-action__hr"/>
            <div className="product-info-action__status">
                <label className="product-info-action__status-label">Trạng thái</label>
                {
                    state.quantityKW > 0 && (
                        <span className="product-info-action__status-badge">
                            <i className="fa-solid fa-check"></i>còn hàng
                        </span>
                    )
                }
                {
                    state.quantityKW <= 0 && (
                        <span className="product-info-action__status-badge out-of-stock">
                            hết hàng
                        </span>
                    )
                }
            </div>
            <div className="product-info-action__price">
                {state.product?.priceSale != "0" && <span className="old-price">{state.product?.priceSale}đ</span>}
                <span className="new-price">{state.price}đ</span>
            </div>
            <hr className="product-info-action__hr"/>
            <p className="product-info-action__desc" dangerouslySetInnerHTML={{__html: state.product?.lead}}/>
            <hr className="product-info-action__hr"/>
            <div className="product-info-action__options">
                {state.product?.productProperties?.length > 0 && state.product?.productProperties?.map(item => {
                    let listV = item?.productPropertieValue ?? [];
                    return (
                        <div key={item.id} className="product-info-action__option">
                            <label className="product-info-action__opt-label">{item.name}</label>
                            <div className="product-info-action__option-items">
                                {
                                    listV.length > 0 && listV.map(itemV => {
                                        return (
                                            <div key={itemV.id} className="product-info-action__option-item">
                                                <input type="radio" checked={method.isChecked(item.id,itemV.id)} id={"p_" + itemV.id} name={item.id} value={itemV.id} onChange={method.selectProperties}/>
                                                <label htmlFor={"p_" + itemV.id}>{itemV.value}</label>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    );
                })}
                <div className="product-info-action__option">
                    <label className="product-info-action__opt-label">Số lượng</label>
                    <div className="product-info-action__option-items">
                        <div className="input-group input-group-sm">
                            <div className="input-group-prepend">
                                <button className="btn btn-outline-gray" type="button"
                                        onClick={(e) => method.clickQuantityBuy(1)}>
                                    <i className="fa-solid fa-minus"></i>
                                </button>
                            </div>
                            <input type="number" className="form-control text-center input-number-appearance"
                                   onChange={method.changeQuantityBuy} value={state.quantityBuy}/>
                            <div className="input-group-append">
                                <button className="btn btn-outline-gray" type="button"
                                        onClick={(e) => method.clickQuantityBuy(2)}>
                                    <i className="fa-solid fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        {
                            state.quantityKW > 0 && (
                                <label className="product-info-action__quantity">(Còn {formatNumber(state.quantityKW)} sản
                                    phẩm)</label>)
                        }
                    </div>
                </div>
                <div className="product-info-action__btn">
                    {state.canBy && (<>
                        <button className="btn btn-red-heavy w-sm-100" type={"button"}
                                onClick={(e) => method.saveCart(e)} disabled={state.disable}>
                            Thêm vào giỏ hàng
                        </button>
                        <button className="btn btn-red w-sm-50" type={"button"} onClick={method.saveOrder}
                                disabled={state.disable}>Đặt hàng
                        </button>
                    </>)}
                    <button className="btn btn-yellow w-sm-50" type={"button"} onClick={method.savePreOrder}>Đặt hàng
                        trước
                    </button>
                </div>
                <span className="product-helper-danger">{state.err}</span>
            </div>
        </>
    )
}

export default MainView;